<template>
  <div>
    <div class="indicator-outer flex justify-between">
      <div class="indicator" v-for="(item,index) in userList" :key="index">
        <!-- <div class="bg"></div> -->
        <div class="postion">
          <img class="pos-line" src="@/assets/images/index/line.png"/>
          <img class="pos-logo" src="@/assets/images/index/evaluation_logo.png"/>
          <div>
            <p class="counts">{{item.counts}}</p>
            <p class="text">{{item.text}}</p>
          </div>
          <!-- 电池仓页面样式有区别 -->
          <div v-if="type=='batteryHolder'">
            <p class="counts">{{item.percent}}</p>
            <p class="text">对比上个月</p>
          </div>
          <div v-else class="evaluationIcon flex-direction text-12">
            <!-- 改成饼图 -->
            <!-- <Echart
              :options="options"
              id="equipmentFailure"
              height="100px"
              width="100px"
            ></Echart> -->
            <div class="text-center evaluationIcon-inner">
              {{item.percent}}
              <p class="text-xsss">完成度</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Echart from '@/common/echart'

export default {
  data () {
    return {
      options: {
        color:['#00D3FF','#1953FC'],
        tooltip: {
            trigger: 'item'
        },
        graphic:{
          type:"text",
          left:"center",
          top:"center",
          style:{
            text:"0%",
            textAlign:"center",
            fill:"#fff",
            fontSize:12,
            fontWeight:400
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '70%'],
            center:['50%','50%'],
            data: [
              {value: 0},
              {value: 0},
            ],
            labelLine: {
              show: false
            },
            label:{
              show:true,
            },
            // itemStyle: {
            //   normal: {
            //     color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //       { offset: 0, color: "#00D3FF" },
            //       { offset: 0.5, color: "#1953FC" }
            //     ])
            //   }
            // },
          },
        
        
        ] 
      },
    };
  },
  components: {
    Echart
  },
  props: {
    userList: {
      type: Array,
      default: () => ({})
    },
    type:{
      type:String,
      default:''
    }
  },
  watch: {
    
  },
  mounted () {
    
  }
}
</script>
<style lang="scss" scoped>


.taskIndicators{
  width:1550px;
}
.indicator{
  min-width:500px;
  height:122px;
  display: flex;
  margin-top:20px;
  // margin-bottom:30px;
  .postion{
    width:100%;
    height:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right:20px;
    background: linear-gradient(180deg, rgba(47, 164, 159, 0.11) 0%, rgba(1, 177, 169, 0.06) 79%, rgba(53, 149, 147, 0.11) 100%);
    .pos-line{
      width:6px;
      height:62px;
    }
    .pos-logo{
      width:32px;
      height:32px;
    }
    .evaluationIcon{
      width:100px;
      height:100px;
      background:url('~@/assets/images/index/evaluation_icon.png');
      background-size:cover;
      display:flex;
      align-items: center;
      justify-content: center;
      animation: rotate 3s linear infinite;
      .evaluationIcon-inner{
        // transform:none;
        animation: internalAvatar 3s linear infinite;
      }
    }
  }
  .counts{
    font-size: 36px;
  }
  .text{
    font-size: 16px;
  }

  
}
// 定义外部旋转动画
@keyframes rotate {
    0% {transform:rotate(0deg);}
    25% {transform:rotate(90deg);}
    50% {transform: rotate(180deg);}
    100% {transform: rotate(360deg);}
}
// 定义内部旋转动画
@keyframes internalAvatar {
  0%{
    transform: rotate(0deg);
  }
  25%{
    transform: rotate(-90deg);
  }
  50%{
    transform: rotate(-180deg);
  }
  100%{
    transform: rotate(-360deg);
  }
}
</style>